import React from "react";
import { JOURNEY_STAGES } from "../../lib/onboardingConfig";
import { Check, ShieldCheck } from "lucide-react";
import { cn } from "../../lib/utils";

export function JourneyRail({ currentIndex, maxReached = 0, onStageClick }) {
  return (
    <div className="hidden lg:flex flex-col w-72 shrink-0 border-r border-border bg-surface p-6" data-testid="journey-rail">
      <div className="flex items-center gap-2.5 mb-1">
        <div className="h-8 w-8 bg-accent flex items-center justify-center rounded-sm">
          <ShieldCheck className="h-4 w-4 text-black" strokeWidth={2.5} />
        </div>
        <div className="font-display font-bold tracking-tight text-lg">LESTARI</div>
      </div>
      <div className="label-eyebrow mb-8">Self-service onboarding</div>

      <div className="space-y-1 relative">
        {JOURNEY_STAGES.map((s, i) => {
          const done = i < currentIndex;
          const active = i === currentIndex;
          const navigable = i >= 1 && i <= maxReached && i !== currentIndex && typeof onStageClick === "function";
          const Wrapper = navigable ? "button" : "div";
          return (
            <Wrapper
              key={s.key}
              type={navigable ? "button" : undefined}
              onClick={navigable ? () => onStageClick(i) : undefined}
              data-testid={`rail-${s.key}`}
              className={cn(
                "flex items-start gap-3 py-2 w-full text-left rounded-sm transition-colors",
                navigable && "hover:bg-surface-hover cursor-pointer group"
              )}
            >
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "h-7 w-7 flex items-center justify-center rounded-sm text-xs font-mono shrink-0",
                    done && "bg-accent text-black",
                    active && "border-2 border-accent text-foreground",
                    !done && !active && "border border-border text-muted-foreground"
                  )}
                >
                  {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
                </div>
                {i < JOURNEY_STAGES.length - 1 && <div className="w-px h-6 bg-border mt-1" />}
              </div>
              <div className={cn("pt-1", !active && !done && "opacity-60")}>
                <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Step {i + 1}</div>
                <div className={cn("text-sm font-medium", navigable && "group-hover:text-accent")}>{s.label}</div>
                {navigable && <div className="text-[10px] text-accent/70 font-mono mt-0.5">Edit</div>}
              </div>
            </Wrapper>
          );
        })}
      </div>

      <div className="mt-auto pt-8">
        <div className="text-[11px] text-muted-foreground leading-relaxed border border-border rounded-sm p-3 bg-background/50">
          <span className="font-mono text-accent">CAPTURE STEP</span> · No account is created yet. We'll email you a
          secure link to create your login and provision your workspace.
        </div>
      </div>
    </div>
  );
}
